import VictimForm, { VictimFormData } from "../VictimForm";
import { Breadcrumbs } from "#root/components/Breadcrumbs";
import { withOfflineSupport } from "#root/utils/offlineWrapper";
import { OFFLINE_OPERATIONS } from '#root/utils/offlineOperations';
import { useVictimOperations } from '#root/hooks/useVictimOperations';
import { useRef, useState } from "react";
import { showToast } from "#root/components/GlobalToaster";

const AddVictim: React.FC = () => {
    const [formKey, setFormKey] = useState(0);
    const containerRef = useRef<HTMLDivElement>(null);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const victimOperations = useVictimOperations();

    const handleSubmit = async (victim: VictimFormData, onSuccess?: () => void) => {
        try {
            setIsSubmitting(true);
            await withOfflineSupport({
                operationType: OFFLINE_OPERATIONS.VICTIM.CREATE,
                operationData: victim,
                operations: {
                    victimOperations
                },
                metadata: { formData: victim },
                successMessage: 'Victim created successfully',
                onSuccess: () => {
                    setFormKey(prev => prev + 1);
                    containerRef.current?.scrollIntoView({ behavior: 'smooth' });
                    onSuccess?.();
                },
                onQueued: () => {
                    setFormKey(prev => prev + 1);
                    containerRef.current?.scrollIntoView({ behavior: 'smooth' });                }
            });
        } catch (error) {
            showToast('Failed to create victim', 'error');
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="add-contact" ref={containerRef}>
            <div className="emc-page-header">
                <div className="emc-page-header__top-row">
                    <div className="emc-page-header__breadcrumbs">
                        <Breadcrumbs />
                    </div>
                </div>
                <div className="emc-page-header__title">
                    <h2>New Entry <div className="divider"></div></h2>
                </div>
            </div>

            <VictimForm
                key={formKey}
                onSubmit={handleSubmit}
                submitButtonText="Add"
                isSubmitting={isSubmitting}
            />
        </div>
    );
};

export default AddVictim;
